// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.lease.CloneLeaseWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CloneLeaseRequestDto, CloneLeaseResponseDto } from '../..';

export const CloneLeaseWebApiHandler_cloneLease_Path = '/api/web/v1/lease/cloneLease';

/**
 * clone existing lease and migrate to newer template if available
 */
export const CloneLeaseWebApiHandler_cloneLease = (postData: CloneLeaseRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, CloneLeaseRequestDto, CloneLeaseResponseDto>(
    {
      endpoint: CloneLeaseWebApiHandler_cloneLease_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};
